import i18nFactory from '@yandex-int/i18n';
import { uniqueId } from 'lodash';

import { Action } from '../../../actions';
import { PageStatus, ValidationErrorData } from '../../../typings/common';
import { State } from '../../../typings/state';
import { mergeTemplateWithVideoResources } from '../../api/mappers';
import { VideoCreatorResourceType } from '../../VideoCreatorHelper/typings';
import {
    CHANGE_VIDEO_CREATOR_PAGE_STATUS,
    CHANGE_VIDEO_CREATOR_VIDEO_NAME,
    SAVE_VIDEO_FROM_VIDEO_CREATOR,
    SHOW_VIDEO_CREATOR_PARAMS_ERRORS,
    UPDATE_VIDEO_CREATOR_DATA_FOR_EDIT,
    UPDATE_VIDEO_CREATOR_PARAM,
    UPDATE_VIDEO_CREATOR_PLAYER_OPTIONS
} from '../actions';
import { VideoCreatorEditState } from '../typings';

import * as keyset from './reducer.i18n';

const i18n = i18nFactory(keyset);

export const getVideoCreatorEditPageInitialState = (): VideoCreatorEditState => ({
    isNew: false,
    pageStatus: PageStatus.LOADING,
    id: uniqueId('video'),
    name: i18n('new-video'),
    template: {
        scenes: [],
        duration: {
            min: 0,
            max: 0,
            default: 0,
            current: 0
        }
    },
    errors: [],
    videoResources: {},
    playOptions: {
        startTime: 0,
        paused: true,
        repeat: true
    }
});

export function videoCreatorEdit(
    state: VideoCreatorEditState = getVideoCreatorEditPageInitialState(),
    action: Action,
    fullState: State
): VideoCreatorEditState {
    switch (action.type) {
        case UPDATE_VIDEO_CREATOR_DATA_FOR_EDIT:
            const template = action.template;
            const { id, name } = template;
            const templateId = id ? id : state.id;
            const templateName = name ? name : state.name;

            return {
                ...state,
                id: templateId,
                name: templateName,
                pageStatus: PageStatus.LOADED,
                template: template,
                videoResources: action.videoResources
            };
        case UPDATE_VIDEO_CREATOR_PARAM:
            const paramValue = state.videoResources[action.id];
            const newResources = {
                ...state.videoResources,
                [action.id]: {
                    ...paramValue,
                    ...action.param
                }
            };

            let newErrors;

            // Обработка ошибок сейчас доступна только для текстовых ресурсов
            if (paramValue.resourceType === VideoCreatorResourceType.text) {
                newErrors = state.errors.reduce((acc: ValidationErrorData[], item) => {
                    if (item.path !== action.id) {
                        acc.push(item);
                    }

                    return acc;
                }, []);
            } else {
                newErrors = state.errors;
            }

            return {
                ...state,
                template: {
                    ...mergeTemplateWithVideoResources(state.template, newResources)
                },
                videoResources: {
                    ...newResources
                },
                errors: newErrors
            };
        case UPDATE_VIDEO_CREATOR_PLAYER_OPTIONS:
            return {
                ...state,
                playOptions: {
                    ...state.playOptions,
                    ...action.options
                }
            };
        case CHANGE_VIDEO_CREATOR_VIDEO_NAME:
            return {
                ...state,
                name: action.name
            };
        case SAVE_VIDEO_FROM_VIDEO_CREATOR:
            return {
                ...state,
                errors: [],
                pageStatus: PageStatus.SAVING
            };
        case SHOW_VIDEO_CREATOR_PARAMS_ERRORS:
            return {
                ...state,
                errors: action.errors,
                pageStatus: PageStatus.LOADED
            };
        case CHANGE_VIDEO_CREATOR_PAGE_STATUS:
            return {
                ...state,
                pageStatus: action.pageStatus
            };
        default:
            return state;
    }
}
